import type { AppDispatch } from '@/store'
import { atualizarKiosk, resetarKiosk, type SelfServiceKioskState } from '@/store/self-service-kiosk-slice'
import { limparSessaoTotem } from '@/lib/sessao-totem'
import { comTransicao } from '@/lib/transicao-view'

export type MudancaKiosk = Partial<SelfServiceKioskState> & {
  currentView: SelfServiceKioskState['currentView']
}

export function trocarView(dispatch: AppDispatch, mudanca: MudancaKiosk) {
  comTransicao(() => dispatch(atualizarKiosk(mudanca)))
}

export function resetarView(dispatch: AppDispatch) {
  limparSessaoTotem()
  comTransicao(() => dispatch(resetarKiosk()))
}
